<button
  class="ice-icon-button"
  type="button"
  [attr.aria-label]="ariaLabel()"
  [attr.data-testid]="testId()"
  [ngStyle]="{ width: size, height: size }"
  (click)="clicked.emit()"
>
  <mat-icon [ngStyle]="{ width: size, height: size }" [svgIcon]="iconName" />
</button>
